import { isPlainObject } from '../../utils/isPlainObject/isPlainObject.js';
import { withRetry, createError } from '../../utils/requests/withRetry.js';

const endpoint = import.meta.env.VITE_CONTEXT_ENGINE_CAMPAIGNS_ENDPOINT;

/**
 * Fetches offers that are contained inside a variation container from CMS.
 *
 * @param {String} slotId The selected slot of the campaign.
 * @param {String} overrideUrl The url that overrides the actual referer.
 * @param {subeventId} subeventId number of subeventId to pass down to Api
 * @param {Object} [contextualConfig={sport, competition, participants, participant}] The configuration that is needed for contextual campaigns.
 * @returns {Promise} Returns a promise that resolves to the campaign's data or rejects if request fails for any reason.
 */
export const fetchCampaignData = async (
  slotId,
  overrideUrl,
  contextualConfig
) => {
  const makeRequest = async attempt => {
    const host = {
      referer: overrideUrl || window.location.href,
      slot: slotId || ''
    };
    const hostToBase64 = window.btoa(JSON.stringify(host));

    const headers = { 'Content-Type': 'application/json' };
    if (attempt > 0) headers['x-retry'] = attempt.toString();

    const req = await fetch(`${endpoint}?json&host=${hostToBase64}`, {
      method: 'POST',
      headers,
      body: isPlainObject(contextualConfig)
        ? JSON.stringify({ context: { ...contextualConfig } })
        : ''
    });

    if (req.status === 204) {
      throw createError(
        'No Campaign Found',
        req.status,
        req.statusText,
        'No Campaign Found',
        'fetchCampaignData'
      );
    }

    if (!req.ok) {
      throw createError(
        `HTTP ${req.status} ${req.statusText}`,
        req.status,
        req.statusText,
        await req.text(),
        req.status < 500 ? 'fetchCampaignData' : undefined
      );
    }

    return req.json();
  };

  try {
    return await withRetry(makeRequest);
  } catch (error) {
    console.log(error);
    if (!error.errorOrigin) error.errorOrigin = 'fetchCampaignData';
    throw error;
  }
};
